(() => {
  if (window.ucwPdpPaper) return;
  window.ucwPdpPaper = true;
  const { quantity, postCart, showError } = window.UcwPdpUtils;
  const init = (root) => {
    if (root.dataset.ucwPaperInitialized) return;
    const button = root.querySelector('[data-ucw-paper-add]');
    const input = root.querySelector('[data-ucw-paper-quantity]');
    if (!button || !input) return;
    root.dataset.ucwPaperInitialized = 'true';
    const isBox = root.dataset.paperBox === 'true';
    const label = () => {
      const amount = quantity(input.value);
      const unit = isBox ? (amount === 1 ? 'doos' : 'dozen') : (amount === 1 ? 'pak' : 'pakken');
      const text = `Voeg ${amount} ${unit} toe aan winkelwagen`;
      button.setAttribute('aria-label', text);
      if (button.dataset.paperText === 'true') button.textContent = text;
    };
    root.querySelector('[data-ucw-paper-minus]')?.addEventListener('click', () => { input.value = Math.max(1, quantity(input.value) - 1); label(); });
    root.querySelector('[data-ucw-paper-plus]')?.addEventListener('click', () => { input.value = quantity(input.value) + 1; label(); });
    input.addEventListener('input', label);
    input.addEventListener('change', () => { input.value = quantity(input.value); label(); });
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      if (button.disabled) return;
      const amount = quantity(input.value);
      input.value = amount;
      label();
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      showError(root, '');
      try {
        await postCart('update', { attributes: { 'upsell-extra-papier': 'ja' } });
        await postCart('add', { items: [{ id: Number(root.dataset.productId), quantity: amount }] });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'upsellPapierToegevoegd', productType: root.dataset.productType,
          printerMerk: root.dataset.printerBrand, isDoos: isBox, quantity: amount,
          productHandle: root.dataset.paperHandle, variantId: Number(root.dataset.productId)
        });
        document.dispatchEvent(new CustomEvent('ucw:cart-added', { detail: { productTitle: root.dataset.paperTitle } }));
      } catch (error) {
        showError(root, error.message);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
    label();
  };
  const scan = (root) => root.querySelectorAll('[data-ucw-paper-upsell]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
